import { AssignmentModel } from "@bryntum/schedulerpro";
import { PlanViewModelMixin } from "./mixins/PlanViewModelMixin";

const TaskAssignmentMixin = Target => class TaskAssignmentMixin extends PlanViewModelMixin(Target) {
  static get fields() {
    return [
      { name: "resourceId", dataSource: "task" },
      { name: "eventId", dataSource: "event" }
    ];
  }

  get task() {
    return this.swivuProject.extraTaskStore.getById(this.resourceId);
  }
}

export class PlanTaskAssignment extends TaskAssignmentMixin(AssignmentModel) {
  static get $name() {
    return "PlanTaskAssignment";
  }
}

PlanTaskAssignment.exposeProperties();
